'use strict';

import {getCookie, setCookie} from "../cookies/setAndGetCookies.js";
import {isMobile, settingsData} from "../../settings";
import { createHtmlElement } from '../../functions';
import { headerState } from '../header/header';
import { resizeCanvasWhenMenuOpened, setMenuPositionDataAttribute, updatePagesStyle } from '../menu/menu';
import {changeSearchModulePosition} from "../search/search";
import {
    changeOptionsCardGalleryDirection,
    renameTowerNameInOptionCard,
    setWidthOfCardDependingOnMenu,
} from '../cards/optionsCards';
import {CardTypes} from "../../common";
import { galleryUpdate } from '../widgets/gallery/galleryMobile';
import { aboutUpdate } from '../widgets/about/aboutv3';
import {
    mapUpdate, resetPanoramaService,
} from '../widgets/poi/poiv3';
import {compassPositionChange} from "../compass/compass";
import { canvasResize, updateLabels } from '../../app';
import {
    changeContactUsModulePosition,
} from "../contactUs/contactUs";
import {applyNow, closeBtnHandler} from "../apply-now/applyNow";
import {applyNowContent} from "../apply-now/applyNowContent";
import { updateDesktopGallery } from '../widgets/gallery/galleryDesktop';
import {changeGridTexture} from "../cylinderGrid/cylinderGrid";
import {createStreetNames} from "../street-names/addStreetNames";
import {dragUnitCard} from "../cards/cardsAnimation";
import { updateMapPanoramaInOrbit } from '../poi/poiCss';
import {recreateBlockWhenLangSwitch} from "../search/similarSearch";
import {changeUnitCardPosition} from "../cards/unitCards/unitCardFunctions";
import {setCompareButtonPosition} from "../navigation/compareButton";
import { changeNotiflixNotifyPosition } from '../analytics/statistic';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import { BuildingSwitch } from '../building-switch/building_switch';
import { changeGetAppModulePosition } from '../getApp/getApp';
import { contactFormChangeLanguage } from '../chats/chats';
import {PrivacyAndTerms} from "../menu/PrivacyAndTerms";

const languageFlags = [
    {
        lang: 'en',
        text: 'English',
        className: 'icon-USA2',
        node: `<span class="icon-USA2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span><span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span><span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span><span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span><span class="path40"></span><span class="path41"></span><span class="path42"></span><span class="path43"></span><span class="path44"></span><span class="path45"></span><span class="path46"></span><span class="path47"></span><span class="path48"></span><span class="path49"></span><span class="path50"></span><span class="path51"></span><span class="path52"></span><span class="path53"></span><span class="path54"></span><span class="path55"></span><span class="path56"></span><span class="path57"></span><span class="path58"></span></span>`,
    },
    {
        lang: 'he',
        text: 'Hebrew',
        className: 'icon-Israel2',
        node: `<span class="icon-Israel2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>`,
    },
    {
        lang: 'ru',
        text: 'Russian',
        className: 'icon-Russia2',
        node: `<span class="icon-Russia2"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>`,
    },
    {
        lang: 'fr',
        text: 'France',
        className: 'icon-fr',
        node: `<span class="icon-fr"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>`
    },
    {
        lang: 'sp',
        text: 'Spain',
        className: 'icon-spain',
        node: `<span class="icon-spain"><span class="path1"></span><span class="path2"></span><span class="path3"></span>
               <span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span>
               <span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span>
               <span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span>
               <span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span>
               <span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span>
               <span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span>
               <span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span>
               <span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span>
               <span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span>
        </span>`
    }
];

export const langSwitcher = ({languages}) => {
    const languagesArr = languages.map(lang => lang.toLowerCase());

    const currentLang = getCurrentLang();
    changeContentText(currentLang);
    // addLangSwitcherWithoutHeader();

    if (languagesArr.length > 1) {
        addLangDropDownList(languagesArr,languages,currentLang);
        document.addEventListener('mousedown',(e)=> closeAllDropDownLang(e));
        document.addEventListener('touchstart',(e)=> closeAllDropDownLang(e));
    }
}

function addLangSwitcherWithoutHeader () {
    const header = document.querySelector('header');
    if (!header){
        const leftContainer = document.querySelector('.left-nav-bar');
        const langSwitcher = createHtmlElement('','','div',['header__lang-toggle','icon-site']);
        leftContainer.insertAdjacentElement('beforebegin',langSwitcher);
    }
}

export function langToggleHandler (e) {
    let element;
    if (e.target.classList.contains('lord__icon')){
        element = e.target.closest('.header__lang-toggle').querySelector('.lang-items__list');
    } else {
        element = e.target.firstElementChild;
    }

    setActiveLang(element);

    if (element.classList.contains('lang-items__list__hide')){
        element.classList.remove('lang-items__list__hide');
    }
}

export function closeAllDropDownLang (e) {
    if (!isDesktopMode()) return;

    const parent = e.target.closest('.lang__item');
    if (parent){
        return;
    }
    const dropDownLangList = document.querySelector('.lang-items__list:not(.lang-items__list__hide)');
    if (dropDownLangList){
        dropDownLangList.classList.add('lang-items__list__hide');
    }

    // const parent = e.target.closest('.lang__item');
    // if (parent){
    //     return;
    // }
    // const allContainer = document.querySelectorAll('.lang-items__list');
    // allContainer.forEach(list =>{
    //     list.classList.add('lang-items__list__hide');
    // })
}

function setActiveLang (langContainer) {
    const currentLang = getCurrentLang();
    const activeLang = langContainer.querySelector('.lang__item.lang__active');
    if (currentLang !== activeLang.dataset.lang){
        activeLang.classList.remove('lang__active');
        const newLangElement = langContainer.querySelector('.lang__item[data-lang="'+currentLang+'"]');
        newLangElement.classList.add('lang__active');
    }
}

function addLangDropDownList (langsArr,languages,currentLang) {
    const allToggle = document.querySelectorAll('.header__lang-toggle');
    allToggle.forEach(el =>{
        addLangToMobileMenu(el,langsArr,languages,currentLang);
        el.addEventListener('click',(e)=>langToggleHandler(e));
    });
}

function addLangToMobileMenu (container,langsArr,languages,currentLang) {
    let langListItemsClassList = ['lang-items__list','lang-items__list__hide'];
    if (!isDesktopMode()) {
        container = document.getElementsByClassName('aside__language-switcher')[0];
        langListItemsClassList = ['lang-items__list'];
    }

    const langListItems = createHtmlElement(container,'','ul',langListItemsClassList);

    langsArr.forEach(lng =>{
        const {lang, node, text} = languageFlags.find(item => item.lang === lng);
        const lngBtn = createHtmlElement(langListItems,'','li',['lang__item']);
        const flag = createHtmlElement(lngBtn,'','span',['lang__flag']);
        if (isDesktopMode())
            createHtmlElement(lngBtn,text,'span',['lang__text']);
        flag.innerHTML = (node) ? node : lang;
        lngBtn.dataset.lang = lng;

        if (currentLang === lng){
            lngBtn.classList.add('lang__active');
        }

    });

    langListItems.addEventListener('click', (e) => mobileLangHandler(e,languages));
}

function mobileLangHandler (e,languages) {
    e.stopImmediatePropagation();
    const parent = e.target.closest('.lang__item');
    const lng = languages.find(item => item === parent.dataset.lang);

    if (lng === getCurrentLang()) return;

    setDomElementLangChanges(lng, parent);
    changeContentText(lng);
    changeLangInIframe(lng);
    headerState(true);
}

function changeLangInIframe (lang) {
    const allFrames = document.querySelectorAll('.content__page');
    allFrames.forEach(frame =>{
       const newUrl = new URL(frame.src);
       newUrl.searchParams.set('lang',lang);
       frame.src = newUrl.href;
    });

    if (isMobile && UnitCardClass.findCard()?.html) {
        changeUnitCardPosition();
        compassPositionChange();
    }
}

export function setInitialHtmlDirection (settings) {
    const languagesArr = settings.languages.map(lang => lang.toLowerCase());
    let currentLang = languagesArr[0];

    if (!getCookie('language')) {

        if (settings.general.defaultLanguage){
            const defLanguage = settings.general.defaultLanguage;

            currentLang = languagesArr.includes(defLanguage) ? defLanguage : languagesArr[0];

        } else {

            let userLang = window.navigator.language.toLowerCase().split('-')[0];
            currentLang = settings.languages.includes(userLang) ? userLang : languagesArr[0];
        }

    } else {
        currentLang = getCookie('language');

        if (!languagesArr.includes(currentLang)){

            if (settings.general.defaultLanguage){
                const defLanguage = settings.general.defaultLanguage;
                currentLang = languagesArr.includes(defLanguage) ? defLanguage : languagesArr[0];
            } else {
                let userLang = window.navigator.language.toLowerCase().split('-')[0];
                currentLang = settings.languages.includes(userLang) ? userLang : languagesArr[0];
            }
        }

    }


    const html = document.querySelector('html');
    html.setAttribute('lang', currentLang);
    html.setAttribute('dir', (currentLang === 'he') ? 'rtl' : 'ltr');
    setCookie('language', currentLang, {'max-age': 365 * 2 * 24 * 60 * 60 * 1000});

    return currentLang;
}

async function setDomElementLangChanges(currentLang, selectedLang) {
    const applyNowBlock =  document.querySelector(`.apply__main-container:not(.chats)`);
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);

    settingsData.switchLang = true;
    const html = document.querySelector('html');
    html.setAttribute('lang', currentLang);
    html.setAttribute('dir', (currentLang === 'he') ? 'rtl' : 'ltr');
    setCookie('language', currentLang, {'max-age': 365 * 2 * 24 * 60 * 60 * 1000});

    const langContainer = selectedLang.parentElement;
    const activeLang = langContainer.querySelector('.lang__item.lang__active');
    activeLang.classList.remove('lang__active');
    selectedLang.classList.add('lang__active');

    if (isDesktopMode())
        langContainer.classList.add('lang-items__list__hide');
    // updateMenuStyleWhenLangChanged();
    updatePagesStyle();

    BuildingSwitch.changeLanguage();
    changeSearchModulePosition();
    changeContactUsModulePosition();
    changeGetAppModulePosition();
    contactFormChangeLanguage();
    galleryUpdate();
    updateDesktopGallery();
    aboutUpdate();
    mapUpdate();
    updateLabels();
    updateMapPanoramaInOrbit();
    PrivacyAndTerms.updateItems();
    resetPanoramaService();
    // await changePoiLanguage();
    createStreetNames();
    // changePlaceholder(document.querySelector('.contact-us'));
    canvasResize();
    // resizeCanvasWhenMenuOpened();
    setMenuPositionDataAttribute();
    changeGridTexture();
    if (!isMobile) {
        changeUnitCardPosition();
        setTimeout(() => dragUnitCard(), 200);
        if (applyNowBlock) {
            closeBtnHandler();
            applyNow(document.body, applyNowContent, false, ['print-btn', 'popup-btn.icon-close'], settingsData.lastClickedFlat);
        }
    }

    if (optionsCard) {
        setWidthOfCardDependingOnMenu();
        recreateBlockWhenLangSwitch();
        changeOptionsCardGalleryDirection();
        changeNotiflixNotifyPosition();
        renameTowerNameInOptionCard();
    }

    UnitCardClass.changeTowerNameWhenLanguageSwitching();

    const compareCards = document.querySelector(`.compare-block`);

    if (compareCards) {
        setWidthOfCardDependingOnMenu(compareCards);
    }

    const compareButton = document.querySelector('.compare-button');
    compareButton && setCompareButtonPosition(compareButton);

}

function changeContentText(currentLang) {
    const textNodes = document.querySelectorAll('.language-string');

    textNodes.forEach(item => {
        if (item.getAttribute('data-dictionary')) {
            if (item.classList.contains('flat-label--subtitle')){
                if (item.getAttribute('data-dictionary') === 'Unavailable'){
                    item.innerText = changeLangToCurrent(item.getAttribute('data-dictionary'));
                }
            } else {
                if (item.getAttribute('data-dictionary-param')) {
                    const param = item.getAttribute('data-dictionary-param');
                    item.setAttribute(param, changeLangToCurrent(item.getAttribute('data-dictionary')));
                } else {
                    item.innerText = changeLangToCurrent(item.getAttribute('data-dictionary'));
                }
            }
        } else if (item.getAttribute('data-lang-en')) {
            item.innerText = item.getAttribute(`data-lang-${getCurrentLang()}`);
        } else if (item.getAttribute('data-dictionary-parse')) {
            const [number, word] = item.textContent.split(' ');
            const text = changeLangToCurrent(item.getAttribute('data-dictionary-parse'));
            item.innerText = `${number} ${text}`;
        } else if (item.getAttribute('data-lord-lang')) {
            item.lastChild.textContent = changeLangToCurrent(item.getAttribute('data-lord-lang'));
        } else {
            item.innerText = item.getAttribute(`data-${currentLang.toLowerCase()}`);
        }
    });

    // changeSearchModulePosition();
    // changeUnitCardPosition();
}

export function getCurrentLang() {
    const currentLang = document.querySelector('html').getAttribute('lang');
    return currentLang;
}

export function getCurrentLangDirection () {
    const direction = document.querySelector('html').getAttribute('dir');
    return direction;
}

export function isDesktopMode () {
    const param = settingsData.isDesktopMode;

    return Boolean(param);
}

export function changeLangToCurrent(word,replaceArray) {
    if (config.dictionary[word]) {

        if (replaceArray && replaceArray.length) {

            replaceArray.forEach(obj => {
                const replacedKey = Object.keys(obj)[0];
                const regExp = new RegExp(`{{${replacedKey}}}`, 'g');

                Object.entries(obj[replacedKey]).forEach(([lang,value]) => {
                    config.dictionary[word][lang] = config.dictionary[word][lang].replace(regExp,value);
                });
            });
        }

        if (config.dictionary[word][getCurrentLang()]) {
            return config.dictionary[word][getCurrentLang()];
        }
    }
    return word;
}

/*export const langSwitcher2 = ({languages}) => {
    languages = ['he', 'en'];
    const languagesArr = languages.map(lang => lang.toLowerCase());
    let currentLang = languages[0].toLowerCase();

    const container = createElements('div', ['lang-container', 'language-switch', 'non-canvas'], document.querySelector('.left-nav-bar'), 'afterbegin');
    const button = createElements('div', ['lang-button', 'language', 'active', 'icon-down2'], container);
    const dropdown = createElements('div', ['lang-dropdown'], container);

    languageUserdetector(button, dropdown, currentLang, languagesArr);

    container.addEventListener('click', (event) => {
        dropdown.classList.toggle('active');
        button.classList.toggle('open');

        changeLanguageByUserSelect(event, button, dropdown, currentLang, languagesArr);
    });
}*/
/*function setActiveLanguage(button, dropdown, currentLang, languages) {
    const html = document.querySelector('html');
    const body = document.querySelector('body');

    button.innerHTML = `${currentLang.toLowerCase()}`;
    dropdown.innerHTML = '';
    languages.forEach(lang => {
        if (lang !== currentLang) {
            dropdown.innerHTML += `<p class="lang-list" data-language=${lang}>${lang}</p>`;
        }

        if (body.classList.contains(lang.toLowerCase())) {
            body.classList.remove(lang.toLowerCase());
        }
    });

    body.classList.add(currentLang.toLowerCase());
    html.setAttribute('lang', currentLang.toLowerCase());
    html.setAttribute('dir', (currentLang === 'he') ? 'rtl' : 'ltr');

    changeContentText(currentLang);
    setCookie('language', currentLang, {'max-age': 9999999});
}*/
/*function languageUserdetector(button, dropdown, currentLang, languages) {

    if (!getCookie('language')) {
        let userLang = window.navigator.language.toLowerCase();
        languages.forEach(lang => (userLang === lang) ? currentLang = userLang : currentLang);
    } else {
        currentLang = getCookie('language');
    }

    setActiveLanguage(button, dropdown, currentLang, languages);
}
function changeLanguageByUserSelect(event, button, dropdown, currentLang, languages) {
    const targetList = document.querySelectorAll('.lang-list');

    targetList.forEach(target => {
        if (event.target === target) {
            const userSelect = event.target.getAttribute('data-language');
            currentLang = userSelect;
            setActiveLanguage(button, dropdown, currentLang, languages);
        }
    });
}*/
